/** Mapbox basemap source ID containing road layers */
export const ROAD_SOURCE = "composite";

/** Source-layer name for road features within the basemap source */
export const ROAD_SOURCE_LAYER = "road";

/** Approximate meters per degree of latitude */
export const METERS_PER_DEG_LAT = 111_320;

/**
 * Returns all map style layer IDs that reference the basemap road source-layer.
 */
export function getRoadLayerIds(map: mapboxgl.Map): string[] {
  return (
    map
      .getStyle()
      .layers?.filter((l) => "source" in l && l.source === ROAD_SOURCE && "source-layer" in l && l["source-layer"] === ROAD_SOURCE_LAYER)
      .map((l) => l.id) ?? []
  );
}
